import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

/** Official store badges, unaltered. Apple's comes first (its guidelines) and has no padding, so it sits flush with left-aligned text at ~43px. Google's PNG carries its own clear-space padding, so 64px tall shows a matching ~43px badge, above Google's minimum. Neither promises a region: both stores exclude the EU/EEA/UK/CH (`docs/infra/security.md` *Markets*). Prerender-safe: used by the marketing hero and `FooterParts`. */
const STORES = [
  {href: 'https://apps.apple.com/us/app/gnothi-ai/id6822923820', src: '/badges/app-store.svg', alt: 'Download on the App Store', width: 129, height: 43},
  {href: 'https://play.google.com/store/apps/details?id=com.gnothiai.app', src: '/badges/google-play.png', alt: 'Get it on Google Play', width: 165, height: 64},
] as const

export default function StoreBadges() {
  return <Stack direction="row" spacing={1} useFlexGap sx={{alignItems: 'center', flexWrap: 'wrap'}}>
    {STORES.map(s => <Box key={s.href} component="a" href={s.href} target="_blank" rel="noopener" sx={{display: 'inline-flex', lineHeight: 0}}>
      <Box component="img" src={s.src} alt={s.alt} width={s.width} height={s.height} sx={{display: 'block'}}/>
    </Box>)}
  </Stack>
}
